var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "location-link-container", class: _vm.style() },
    [
      _c(
        "mq-layout",
        { attrs: { mq: "desktop" } },
        [
          _c("router-link", { attrs: { to: _vm.getRoute() } }, [
            !_vm.isInjectable()
              ? _c("img", {
                  staticClass: "logo",
                  attrs: {
                    alt: "store logo image",
                    src: require("../../assets/store-logo.png"),
                    width: "168",
                    "aria-label": "store home"
                  }
                })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("service-type-info")
        ],
        1
      ),
      _vm._v(" "),
      _c("mq-layout", { attrs: { mq: ["mobile", "tablet"] } }, [
        _c("div", { staticClass: "destination-description" }, [
          _c("div", { staticClass: "location-link-wrapper" }, [
            _c(
              "a",
              {
                staticClass: "location-link",
                attrs: { "aria-label": "store locations page" },
                on: {
                  click: function($event) {
                    return _vm.setModal("locations")
                  }
                }
              },
              [
                _vm._v(
                  "\n\t\t\t\t\t" + _vm._s(_vm.location.name) + "\n\t\t\t\t"
                )
              ]
            )
          ])
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4453d4ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4453d4ed","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/NavigationLocationMobile.vue
// module id = null
// module chunks = 